export default __webpack_public_path__ + "static/reaction-marketing-786df9f4e0c2b998f560eab9c522ad6d.png";